// Core
import React from 'react';

// Hooks
import { useOverflowTooltip } from '../../hooks/useOverflowTooltip/useOverflowTooltip';

// Components
import {
  Paragraph,
  ParagraphSize,
  ParagraphWeight,
} from '../../layout/elements/Paragraph';
import { Tooltip } from '../../layout/elements/Tooltip';

// Component
import {
  Container,
  ContentContainer,
  Image,
  ImageContainer,
  ParagraphContainer,
} from './MaintenanceCard.style';
import { MaintenanceCardProps } from './MaintenanceCard.types';

function MaintenanceCard({
  className,
  imgSrc,
  testId,
  text,
  onClick,
}: MaintenanceCardProps): JSX.Element {
  const {
    containerRef: textContainerRef,
    contentRef: textContentRef,
    isTooltipVisible: renderTooltip,
  } = useOverflowTooltip({
    overflowCheckTriggers: text,
  });

  const renderText: JSX.Element = (
    <ParagraphContainer ref={textContainerRef}>
      <ContentContainer ref={textContentRef}>
        {renderTooltip ? (
          <Tooltip text={text}>
            <Paragraph
              weight={ParagraphWeight.bold}
              size={ParagraphSize.lg}
              preventOverflow
            >
              {text}
            </Paragraph>
          </Tooltip>
        ) : (
          <Paragraph
            weight={ParagraphWeight.bold}
            size={ParagraphSize.lg}
            preventOverflow
          >
            {text}
          </Paragraph>
        )}
      </ContentContainer>
    </ParagraphContainer>
  );

  return (
    <Container
      className={className}
      data-testid={testId}
      onClick={onClick}
    >
      <ImageContainer>
        <Image src={imgSrc} />
      </ImageContainer>
      {renderText}
    </Container>
  );
}

export { MaintenanceCard };
